import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, ArrowRight, Clock } from "lucide-react";
import { company, navLinks, services } from "../mock";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="section-dark text-slate-300">
      {/* CTA strip */}
      <div className="container-x">
        <div className="relative -mt-16 mb-14 rounded-2xl bg-gradient-to-r from-[#0B1F3A] to-[#184E9E] px-8 py-9 md:px-12 md:py-10 flex flex-col md:flex-row items-center justify-between gap-6 shadow-[0_30px_60px_-30px_rgba(0,0,0,.6)]">
          <div>
            <div className="eyebrow text-[#E4C55E] mb-2">Ready When You Are</div>
            <h3 className="font-head text-white text-2xl md:text-3xl font-bold max-w-xl">
              Get an obligation-free B-BBEE quote today
            </h3>
          </div>
          <div className="flex gap-3">
            <Link
              to="/pricing-calculator"
              className="btn-gold inline-flex items-center gap-2 px-6 py-3 rounded-lg"
            >
              Instant Quote <ArrowRight size={18} />
            </Link>
            <Link
              to="/contact"
              className="btn-outline-light inline-flex items-center gap-2 px-6 py-3 rounded-lg"
            >
              Book Consultation
            </Link>
          </div>
        </div>
      </div>

      <div className="container-x grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12">
        <div>
          <div className="mb-5">
            <Logo variant="light" size={40} />
          </div>
          <p className="text-sm leading-relaxed text-slate-400">
            A Broad-Based Black Economic Empowerment consulting and advisory firm
            assisting the corporate sector with all aspects of B-BBEE legislation.
          </p>
        </div>

        <div>
          <h4 className="font-head text-white font-semibold mb-5">Quick Links</h4>
          <ul className="space-y-3 text-sm">
            {navLinks.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-slate-400 hover:text-[#D4AF37] transition-colors inline-flex items-center gap-2"
                >
                  <ArrowRight size={13} className="text-[#D4AF37]" /> {l.label}
                </Link>
              </li>
            ))}
            <li>
              <a
                href={`${process.env.REACT_APP_BACKEND_URL}/api/company-profile/download`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-[#D4AF37] transition-colors inline-flex items-center gap-2"
              >
                <ArrowRight size={13} className="text-[#D4AF37]" /> Company Profile (PDF)
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-head text-white font-semibold mb-5">Our Services</h4>
          <ul className="space-y-3 text-sm">
            {services.slice(0, 5).map((s) => (
              <li key={s.slug}>
                <Link
                  to="/services"
                  className="text-slate-400 hover:text-[#D4AF37] transition-colors inline-flex items-center gap-2"
                >
                  <ArrowRight size={13} className="text-[#D4AF37]" /> {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-head text-white font-semibold mb-5">Get In Touch</h4>
          <ul className="space-y-4 text-sm">
            <li className="flex gap-3">
              <MapPin size={18} className="text-[#D4AF37] shrink-0 mt-0.5" />
              <span className="text-slate-400">{company.address}</span>
            </li>
            {company.phones.map((p) => (
              <li key={p} className="flex gap-3 items-center">
                <Phone size={18} className="text-[#D4AF37] shrink-0" />
                <a href={`tel:${p.replace(/\s/g, "")}`} className="text-slate-400 hover:text-[#D4AF37]">
                  {p}
                </a>
              </li>
            ))}
            <li className="flex gap-3 items-center">
              <Mail size={18} className="text-[#D4AF37] shrink-0" />
              <a href={`mailto:${company.email}`} className="text-slate-400 hover:text-[#D4AF37]">
                {company.email}
              </a>
            </li>
            <li className="flex gap-3 items-center">
              <Clock size={18} className="text-[#D4AF37] shrink-0" />
              <span className="text-slate-400">{company.hours}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-slate-500">
          <span>© {new Date().getFullYear()} {company.full}. All rights reserved.</span>
          <span>B-BBEE Consulting & Advisory · Randburg, South Africa</span>
        </div>
      </div>
    </footer>
  );
}
